import { ListItemText } from '@material-ui/core'
import { BaseTheme } from 'opensolar-ui'
import { CSSProperties, ReactNode } from 'react'
import { useTranslate } from 'react-admin'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const highlightStyle = {
  backgroundColor: BaseTheme.palette.yellow[400],
  borderRadius: 2,
  padding: '0 1px',
}

// TODO: Replace with OSUI ListItemText once the new component is implemented
const useStyles = makeOpenSolarStyles((theme) => ({
  root: {
    margin: 0,
    flex: '1 1 0',
    minWidth: 0,
  },
  primary: {
    fontSize: 14,
    paddingLeft: 40,
    fontWeight: 'inherit',
    fontFamily: BaseTheme.typography.fontFamily,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflow: 'visible',
    textOverflow: 'clip',
  },
}))

export const getHighlightedText = (text: string, highlightText?: string): string | ReactNode[] => {
  const trimmedHighlight = highlightText?.trim()
  if (!trimmedHighlight) return text

  const lowerText = text.toLowerCase()
  const lowerHighlight = trimmedHighlight.toLowerCase()
  const parts: ReactNode[] = []
  let startIndex = 0
  let matchIndex = lowerText.indexOf(lowerHighlight, startIndex)

  while (matchIndex !== -1) {
    if (matchIndex > startIndex) {
      parts.push(text.slice(startIndex, matchIndex))
    }

    const endIndex = matchIndex + trimmedHighlight.length
    parts.push(
      <mark key={`${matchIndex}-${endIndex}`} style={highlightStyle}>
        {text.slice(matchIndex, endIndex)}
      </mark>
    )
    startIndex = endIndex
    matchIndex = lowerText.indexOf(lowerHighlight, startIndex)
  }

  if (startIndex < text.length) {
    parts.push(text.slice(startIndex))
  }

  return parts
}

const MenuItemLinkText = ({ label, style, highlightText }: { label: string; style?: CSSProperties; highlightText?: string }) => {
  const translate = useTranslate()
  const classes = useStyles()
  const translatedLabel = translate(label)
  return (
    <ListItemText
      classes={{ root: classes.root, primary: classes.primary }}
      primary={getHighlightedText(translatedLabel, highlightText)}
      style={style}
    />
  )
}

export default MenuItemLinkText
